/** Spool / weld workflow step saves → POST bodies built in UI panels (FitUp, Preheat, …). */

export const SAVE_SPOOL_FIT_UP = 'SAVE_SPOOL_FIT_UP';
export const SAVE_SPOOL_FIT_UP_SUCCESS = 'SAVE_SPOOL_FIT_UP_SUCCESS';
export const SAVE_SPOOL_FIT_UP_FAILURE = 'SAVE_SPOOL_FIT_UP_FAILURE';

export const SAVE_SPOOL_PREHEAT = 'SAVE_SPOOL_PREHEAT';
export const SAVE_SPOOL_PREHEAT_SUCCESS = 'SAVE_SPOOL_PREHEAT_SUCCESS';
export const SAVE_SPOOL_PREHEAT_FAILURE = 'SAVE_SPOOL_PREHEAT_FAILURE';

export const SAVE_SPOOL_WELDING = 'SAVE_SPOOL_WELDING';
export const SAVE_SPOOL_WELDING_SUCCESS = 'SAVE_SPOOL_WELDING_SUCCESS';
export const SAVE_SPOOL_WELDING_FAILURE = 'SAVE_SPOOL_WELDING_FAILURE';

export const SAVE_SPOOL_VT = 'SAVE_SPOOL_VT';
export const SAVE_SPOOL_VT_SUCCESS = 'SAVE_SPOOL_VT_SUCCESS';
export const SAVE_SPOOL_VT_FAILURE = 'SAVE_SPOOL_VT_FAILURE';

export const SAVE_SPOOL_NDT = 'SAVE_SPOOL_NDT';
export const SAVE_SPOOL_NDT_SUCCESS = 'SAVE_SPOOL_NDT_SUCCESS';
export const SAVE_SPOOL_NDT_FAILURE = 'SAVE_SPOOL_NDT_FAILURE';

export const SAVE_SPOOL_COATING = 'SAVE_SPOOL_COATING';
export const SAVE_SPOOL_COATING_SUCCESS = 'SAVE_SPOOL_COATING_SUCCESS';
export const SAVE_SPOOL_COATING_FAILURE = 'SAVE_SPOOL_COATING_FAILURE';

export const SAVE_SPOOL_ACCEPT = 'SAVE_SPOOL_ACCEPT';
export const SAVE_SPOOL_ACCEPT_SUCCESS = 'SAVE_SPOOL_ACCEPT_SUCCESS';
export const SAVE_SPOOL_ACCEPT_FAILURE = 'SAVE_SPOOL_ACCEPT_FAILURE';

export const CLEAR_SPOOL_TRACKER_SAVE_ERROR = 'CLEAR_SPOOL_TRACKER_SAVE_ERROR';

/** GET /spool-tracker/getAllSpools — production grid */
export const FETCH_ALL_SPOOLS = 'FETCH_ALL_SPOOLS';
export const FETCH_ALL_SPOOLS_SUCCESS = 'FETCH_ALL_SPOOLS_SUCCESS';
export const FETCH_ALL_SPOOLS_FAILURE = 'FETCH_ALL_SPOOLS_FAILURE';

/** POST /spool-tracker/ncr/register — workflow NCR (Raise NCR modal) */
export const REGISTER_SPOOL_NCR = 'REGISTER_SPOOL_NCR';
export const REGISTER_SPOOL_NCR_SUCCESS = 'REGISTER_SPOOL_NCR_SUCCESS';
export const REGISTER_SPOOL_NCR_FAILURE = 'REGISTER_SPOOL_NCR_FAILURE';

/** GET /spool-tracker/ncr?project_id=&pipe_id=[&spool_id=] */
export const FETCH_SPOOL_NCR_LIST = 'FETCH_SPOOL_NCR_LIST';
export const FETCH_SPOOL_NCR_LIST_SUCCESS = 'FETCH_SPOOL_NCR_LIST_SUCCESS';
export const FETCH_SPOOL_NCR_LIST_FAILURE = 'FETCH_SPOOL_NCR_LIST_FAILURE';

/** GET /spool-tracker/project-dashboard?project_id=[&pipe_id=] */
export const FETCH_PROJECT_SPOOL_DASHBOARD = 'FETCH_PROJECT_SPOOL_DASHBOARD';
export const FETCH_PROJECT_SPOOL_DASHBOARD_SUCCESS = 'FETCH_PROJECT_SPOOL_DASHBOARD_SUCCESS';
export const FETCH_PROJECT_SPOOL_DASHBOARD_FAILURE = 'FETCH_PROJECT_SPOOL_DASHBOARD_FAILURE';
